<template>
  <VTable
    :items="computedItems"
    :fields="fields"
    :checked-rows="checkedRows"
    :loading="loading"
    :on-toggle-row="onToggleRow"
    :on-input-search="onInputSearch"
    :on-edit-item="onEditItem"
    :on-change-check-box-input="onChangeCheckBoxInput"
    :on-show-comments="onShowComments"
    :on-verification-state-change="onVerificationStateChange"
    :on-delete-item="onDeleteItem"
    searchPlaceholder="Search for car...."
    hideAddButton
    hideCheckHeader
    hover
    striped
    border
    small
    fixed
    dark
  >
    <template #footer>
      <VPagination
        :items-count="itemsCount"
        class="user-manager-card__footer-pagination"
      />
    </template>
  </VTable>
</template>
<script>
import {
  createCarManagerMixin,
  carManagerStore
} from "@/mixins/carManagerMixin";
import { debounce } from "@/utils/debounce";
import ModalType from "@/utils/dictionaries/modalType";
import { getUser } from "@/utils/validation/user";
import {
  getVerificationState,
  getVerificationStatus,
  getVerficationStateColor
} from "@/utils/validation/car";
import api from "@/api/api";
import moment from "moment";
import { auctionManagerStore, createAuctionManagerMixin } from "@/mixins/auctionsManagerMixin";

const defaultImage =
  "https://evbids.blob.core.windows.net/assets/images/NoImage.jpg";

export default {
  name: "VUserManagerTable",

  mixins: [createCarManagerMixin(), createAuctionManagerMixin()],

  components: {},

  data: () => {
    return {
      loading: false,
      lastSearchTerm: null,
      checkedRows: [],
      searchFn: () => {}
    };
  },

  computed: {
    fields() {
      return [
        { key: "rowId", label: "" },
        {
          key: "username",
          label: "Username",
          _style: "min-width: 125px",
          _classes: "username"
        },
        {
          key: "carListing",
          label: "Car",
          _style: "min-width: 275px",
          _classes: "car"
        },
        {
          key: "verificationState",
          label: "Status",
          _style: "min-width: 100px",
          _classes: "verification-status"
        },
        {
          key: "comments",
          label: "Comments",
          _classes: "comments"
        },
        {
          key: "type",
          label: "Type",
          _classes: "comments"
        },
        {
          key: "payOffAmount",
          label: "Payoff Amount",
          _classes: "comments"
        },
        {
          key: "payOffBank",
          label: "Payoff Bank",
          _classes: "comments"
        },
        {
          key: "auctionKind",
          label: "Auction Kind",
          _style: "min-width: 100px",
          _classes: "auction-kind"
        },
        {
          key: "verification",
          label: "Verification",
          _style: "min-width: 150px",
          _classes: "verification"
        },
        {
          key: "date",
          label: "Date",
          _style: "min-width: 150px",
          _classes: "verification"
        },
        {
          key: "isTestMode",
          label: "Test Auction",
          _style: "min-width: 150px",
          _classes: "verification"
        },
        { key: "action", _style: "max-width: 20px;min-width:20px" }
      ];
    },
    items() {
      return this[carManagerStore.getterTypes.GETTER_CARS];
    },
    itemsCount() {
      return this[carManagerStore.getterTypes.GETTER_CARS_COUNT];
    },
    computedItems() {
      return (
        this.items &&
        this.items.map(a => {
          return {
            ...a,
            id: a.id,
            username: a.owner.username,
            car: {
              id: a.id,
              title: a.title,
              uuid: a.uuid,
              year: a.year,
              make: a.make,
              model: a.model,
              createdAt: a.createdAt,
              startDate: a.startDate,
              endDate: a.endDate,
              imageUrl:
              this.findImage(a.carImages),
              showInfo: true,
              showCreatedDate: true,
              showStartDate: true,
              hideLink: true,
              format: "DD.MM.YY hh:mm",
              disabledLink: this.isDisabled(a),
              comments: a.comments
            },
            payOffAmount: a.payOffAmount || "",
            payOffBank: a.payOffBank || "",
            verificationState: this.getVerificationState(a),
            verficationStateColor: this.getVerficationStateColor(a),
            auctionKind: a.reserve ? "reserve" : "no reserve",
            verification: this.getVerificationStatus(a),
            date: a.updatedAt ? moment(a.updatedAt).format('lll') : moment(a.createdAt).format('lll'),
            isTestMode: Boolean(a.isTestMode),
            type: a.type
          };
        })
      );
    },
    isChecked() {
      return this.checkedRows
        .map(row => row.id)
        .reduce((acc, val) => {
          acc[val] = true;
          return acc;
        }, {});
    },
    isReload() {
      return this[auctionManagerStore.getterTypes.GETTER_PAGE_RELOAD];
    },
  },

  watch: {
    isReload(newValue){
      this.loadData();
    },
    checkedRows(rows) {
      if (!this.$refs.table) return;
      const rowsSelector = rows
        .reduce((acc, item) => `[data-row-id="${item.id}"],` + acc, "")
        .replace(/,$/, "");
      const rowsEl =
        rowsSelector.length > 0
          ? this.$refs.table.$el.querySelectorAll(rowsSelector)
          : [];

      const allRowsSelector = this.computedItems
        .reduce((acc, item) => `[data-row-id="${item.id}"],` + acc, "")
        .replace(/,$/, "");
      const allRowsEl =
        allRowsSelector.length > 0
          ? this.$refs.table.$el.querySelectorAll(allRowsSelector)
          : [];

      Array.from(allRowsEl).forEach(row => {
        if (row.parentNode.nodeName === "TR") {
          toggleRowClass(row.parentNode, "user-manager__row-checked", false);
        }
      });

      Array.from(rowsEl).forEach(row => {
        if (row.parentNode.nodeName === "TR") {
          toggleRowClass(row.parentNode, "user-manager__row-checked");
        }
      });
    },
    $route() {
      this.clearCheckboxes();
      this.loadData();
    }
  },

  async created() {
    this[carManagerStore.actionTypes.ACTION_JOIN_TO_CAR_MANAGER]();
    await this.loadData();

    this.searchFn = debounce.call(
      this,
      async term => {
        const query = {
          ...this.$route.query,
          search: term
        };

        if (!query.search && query.offset) {
          query.offset = 0;
        }

        this.$router
          .push({
            query
          })
          .catch(() => {});
      },
      200
    );
  },

  methods: {
    async onChangeCheckBoxInput(item){
      await this[carManagerStore.actionTypes.ACTION_TEST_MODE_CAR]({ id: item.id, isTestMode: !item.isTestMode })
    },
    findImage(carImages){
        if(carImages.length > 0){
          let url = ""
          url = carImages.find(c => c.mainImage === 1 )?.url;
          if(!url){
            url = carImages.find(c => c.illustratorId === 1 )?.url;
          }
          if(!url){
            url = defaultImage
          }
          return url
        }
        return defaultImage
      },
    getVerficationStateColor(car) {
      return getVerficationStateColor(car);
    },
    getVerificationState(car) {
      car.isMarketplace = true;
      return getVerificationState(car);
    },
    getVerificationStatus(car) {
      return getVerificationStatus(car);
    },
    getLastUsers() {
      return this.items
        .map(item => getUser(item))
        .map(u => ({ created_at: u.created_at, id: u.id }));
    },
    isDisabled(car) {
      const state = getVerificationState(car);
      return state !== "Auction";
    },
    clearCheckboxes() {
      this.checkedRows = [];
    },
    onToggleRow({ item }) {
      if (this.isChecked[item.id]) {
        this.checkedRows = [];
      } else {
        this.checkedRows = [item];
      }
    },
    onInputSearch(t) {
      this.searchFn(t);
    },
    onEditItem(item) {
      if (
        item.verificationState === "Auction" ||
        item.verification === "declined"
      ) {
        return this.$modals.open(ModalType.EditCarModal, {
          ...item,
          disabled: false
        });
      }
      this.$modals.open(ModalType.EditCarModal, item);
    },
    onShowComments(item) {
      const { comments, ...itemWithoutComments } = item;
      return this.$modals.open(ModalType.CommentsModal, {
          ...itemWithoutComments,
          disabled: false
        });
    },
    onDeleteItem(item) {
      const deleteAction = async () => {
        try {
          await api.delete(`/cars/${item.id}`);
          this.$modals.close(ModalType.ConfirmationModal);
          this.$router.go();
        } catch (error) {
          console.log(error);
        }
      };

      this.$modals.open(ModalType.ConfirmationModal, {
        title: "Deletion",
        body: `Are you sure you want to delete this car?`,
        buttonText: "Delete",
        onClickButton: deleteAction
      });
    },
    onVerificationStateChange(item, selected) {
      const setApproved = () => {
        console.log("this.computedItems", item);
        this[carManagerStore.actionTypes.ACTION_VERIFY_CAR]({ id: item.id, verificationState: selected })
        this.$modals.close(ModalType.ConfirmationModal);
        this.$modals.open(ModalType.DefaultModal, {
          title: "Added",
          body: `Vehicle ${item.title} has been added into marketplace listing`
        });
        setTimeout(() => {
          this.$modals.close(ModalType.DefaultModal);
        }, 3000);
      };

      if (selected === "approved") {
        this.$modals.open(ModalType.ConfirmationModal, {
          title: "Approve application",
          body: "Are you sure you want to add this vehicle into marketplace listing?",
          buttonText: "Approve",
          buttonPrimary: true,
          onClickButton: setApproved
        });
      } else if (selected === "declined") {
        this.$modals.open(ModalType.DeclineCarModal, item);
      }
    },
    async loadData() {
      this.loading = true;
      await this[carManagerStore.actionTypes.ACTION_LOAD_CARS]({
        take: this.$route.query.take || 10,
        skip: this.$route.query.skip || 0,
        search: this.$route.query.search,
        all: true
      });
      this.loading = false;
    }
  }
};
</script>
